import { useMutation, UseMutationOptions } from "react-query";

import {
  BooleanResponse,
  SampleRequest,
  SampleRequestService,
  UpsertSampleRequestRawMaterialRequest,
} from "../api/public";

export const useUpdateSampleRequestRawMaterialMutation = (
  sampleRequestId: string,
  options?: UseMutationOptions<
    BooleanResponse,
    unknown,
    UpsertSampleRequestRawMaterialRequest,
    SampleRequest
  >
) => {
  return useMutation(
    (request: UpsertSampleRequestRawMaterialRequest) =>
      SampleRequestService.sampleRequestUpsertSampleRequestRawMaterial(
        sampleRequestId,
        request
      ),
    options
  );
};
